var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activation-step-label",class:{ 'activation-step-label-selected': _vm.selected }},[_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }